import React, { useEffect, useState } from 'react';
import './style/UserMngById.css';
import config from './config/config';
import {useNavigate} from "react-router-dom";

const SESSION_TIMEOUT = 10 * 60 * 1000; // 5 минут


const geAllCardListUrl = `${config.apiUrl1}/api/client-cards/get-all-card`;
const  updateCardUrl=`${config.apiUrl1}/api/client-cards/update-card`;
const getProfileDataUrl =`${config.apiUrl2}/api/profile/get-profile-data`;
const apiServiceUrl =`${config.apiUrl2}/api/services`;
const apiServiceUrlsave =`${config.apiUrl2}/api/user-services`;

const UserMngById = ({ phone, onClose,checkCard }) => {
    const [profileData, setProfileData] = useState(null);
    const [activeCarId, setActiveCarId] = useState(null);
    const [services, setServices] = useState([]);
    const [selectedServices, setSelectedServices] = useState([]);
    const [availableCards, setAvailableCards] = useState([]);
    const [selectedCardId, setSelectedCardId] = useState('');
    const navigate = useNavigate();
    const [showAddServices, setShowAddServices] = useState(false); // флаг для "добавить услугу"
    const [newServices, setNewServices] = useState([]); // выбранные для добавления услуги

    const handleToggleNewService = (e, service) => {
        if (e.target.checked) {
            setNewServices(prev => [
                ...prev,
                {
                    id: service.id,
                    service_name: service.name,
                    total_count: 0,
                    remaining_count: 0
                }
            ]);
        } else {
            setNewServices(prev => prev.filter(s => s.id !== service.id));
        }
    };
    const handleNewServiceCount = (e, serviceId) => {
        const value = parseInt(e.target.value) || 0;
        setNewServices(prev =>
            prev.map(s =>
                s.id === serviceId
                    ? { ...s, total_count: value, remaining_count: value }
                    : s
            )
        );
    };

    const handleSaveNewServices = async () => {
        if (!profileData || !profileData.user || !activeCarId) return;

        if (newServices.length === 0) {
            alert("Выберите хотя бы одну услугу");
            return;
        }
        const payload = {
            userId: profileData.user.id,
            carId: activeCarId,
            data: newServices.map(s => ({
                service_id: s.id,
                service_name: s.service_name,
                total_count: s.total_count,
                remaining_count: s.remaining_count
            }))
        };

        try {
            const response = await fetch(apiServiceUrlsave, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                alert("Новые услуги добавлены!");
                setNewServices([]);
                setShowAddServices(false);

                // обновим данные профиля
                const res = await fetch(getProfileDataUrl, {
                    headers: { phone, "User-Agent": "insomnia/11.1.0" }
                });
                const updatedData = await res.json();
                setProfileData(updatedData);
            } else {
                alert("Ошибка при добавлении услуг.");
            }
        } catch (err) {
            console.error("Ошибка сети:", err);
            alert("Ошибка сети.");
        }
    };
        useEffect(() => {
        const fetchCards = async () => {
            try {
                const res = await fetch(geAllCardListUrl);
                if (res.ok) {
                    const data = await res.json();
                    setAvailableCards(data);
                } else {
                    console.error("Ошибка загрузки карт");
                }
            } catch (error) {
                console.error("Ошибка сети при загрузке карт:", error);
            }
        };

        fetchCards();
    }, []);


    const handleBindCard = async () => {
        if (!selectedCardId || !profileData?.user?.id) return;

        try {
            const response = await fetch(updateCardUrl, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'User-Agent': 'insomnia/11.2.0'
                },
                body: JSON.stringify({
                    id: parseInt(selectedCardId),
                    userId: profileData.user.id
                })
            });

            if (response.ok) {
                alert('Карта успешно привязана!');
                if (onClose) onClose(); // закрыть модалку
            } else {
                alert('Ошибка при привязке карты');
            }
        } catch (err) {
            console.error('Ошибка при привязке карты:', err);
            alert('Ошибка сети');
        }
    };


    useEffect(() => {
        if (!phone) return;

        const fetchData = async () => {
            try {
                // Получаем профиль пользователя
                const res = await fetch(getProfileDataUrl, {
                    headers: {
                        'phone': phone,
                        'User-Agent': 'insomnia/11.1.0'
                    }
                });
                const data = await res.json();
                setProfileData(data);

                // Загружаем список доступных услуг
                const resServices = await fetch(apiServiceUrl);
                const serviceList = await resServices.json();
                setServices(serviceList);

            } catch (error) {
                console.error('Ошибка загрузки данных:', error);
            }
        };

        fetchData();
    }, [phone]);

    const handleServiceToggle = (e, service) => {
        if (e.target.checked) {
            setSelectedServices(prev => [
                ...prev,
                {
                    id: service.id,
                    service_name: service.name,
                    total_count: 0,
                    remaining_count: 0
                }
            ]);
        } else {
            setSelectedServices(prev => prev.filter(s => s.id !== service.id));
        }
    };

    const handleSizeChange = (e, serviceId) => {
        const value = parseInt(e.target.value) || 0;
        setSelectedServices(prev =>
            prev.map(s =>
                s.id === serviceId
                    ? { ...s, total_count: value, remaining_count: value }
                    : s
            )
        );
    };

    const handleSubmitServices = async (e) => {
        e.preventDefault();
        if (!profileData || !profileData.carEntityList) return;

        const selectedCar = profileData.carEntityList.find(car => car.id === activeCarId);
        if (!profileData.user || !selectedCar) return;

        if (selectedServices.length === 0) {
            alert('Выберите хотя бы одну услугу');
            return;
        }

        const payload = {
            userId: profileData.user.id,
            carId: selectedCar.id,
            data: selectedServices.map(s => ({
                service_name: s.service_name,
                total_count: s.total_count,
                remaining_count: s.remaining_count
            }))
        };

        try {
            const response = await fetch(apiServiceUrlsave, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                alert('Услуги успешно сохранены!');
                setSelectedServices([]);
                if (onClose) onClose(); // <-- закрываем модальное окно
            } else {
                alert('Ошибка при сохранении услуг.');
            }
        } catch (err) {
            console.error('Ошибка отправки:', err);
            alert('Ошибка сети.');
        }
    };
    if (!profileData) return <div>Загрузка...</div>;

    const selectedCar = profileData.carEntityList.find(car => car.id === activeCarId);

    return (
        <div className="profile-page">
            <div className="user-info">
                <h2>Информация о пользователе</h2>
                <p><strong>ФИО:</strong> {profileData.user.full_name}</p>
                <p><strong>Телефон:</strong> {profileData.user.phone_number}</p>
                <p><strong>Паспорт:</strong> {profileData.user.passport_number}</p>
                {profileData.user.card_number && (
                    <p><strong>Номер карты:</strong> {profileData.user.card_number}</p>
                )}

                {checkCard === false && !profileData.user.card_number && (
                    <div className="dropdown-container">
                        <label htmlFor="cardNumberSelect"><strong>Выберите карту:</strong></label>
                        <select
                            id="cardNumberSelect"
                            className="dropdown-select"
                            value={selectedCardId}
                            onChange={(e) => setSelectedCardId(e.target.value)}
                        >
                            <option value="">-- Выберите --</option>
                            {availableCards.map(card => (
                                <option key={card.id} value={card.id}>
                                    {card.cardNumber} (ID: {card.id})
                                </option>
                            ))}
                        </select>
                        {selectedCardId && (
                            <button className="order-btn" style={{ marginTop: '10px' }} onClick={handleBindCard}>
                                Привязать карту
                            </button>
                        )}
                    </div>
                )}


            </div>

            <div className="car-buttons">
                {profileData.carEntityList.map(car => (
                    <button
                        key={car.id}
                        className={activeCarId === car.id ? 'active' : ''}
                        onClick={() => setActiveCarId(car.id)}
                    >
                        🚗 {car.carNumber}
                    </button>
                ))}
            </div>

            {selectedCar && (
                <div className="car-details">
                    <h3>Информация об авто</h3>
                    <table className="car-table">
                        <tbody>
                        <tr><th>ID</th><td>{selectedCar.id}</td></tr>
                        <tr><th>Марка</th><td>{selectedCar.brandId.name}</td></tr>
                        <tr><th>Модель</th><td>{selectedCar.modelId.name}</td></tr>
                        <tr><th>Год</th><td>{selectedCar.yearId.year}</td></tr>
                        <tr><th>Номер</th><td>{selectedCar.carNumber}</td></tr>
                        <tr><th>Тех. Паспорт</th><td>{selectedCar.techPassport}</td></tr>
                        </tbody>
                    </table>

                    <h4>Услуги</h4>
                    {selectedCar.userServiceEntity?.data &&
                    selectedCar.userServiceEntity.data.length > 0 ? (
                        <>
                            <table className="car-table">
                                <thead>
                                <tr>
                                    <th>Название</th>
                                    <th>Всего</th>
                                    <th>Осталось</th>
                                </tr>
                                </thead>
                                <tbody>
                                {selectedCar.userServiceEntity.data.map((service, idx) => (
                                    <tr key={idx}>
                                        <td>{service.service_name}</td>
                                        <td>{service.total_count}</td>
                                        <td>{service.remaining_count}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>

                            {/* кнопка только под таблицей */}
                            <button
                                className="order-btn"
                                style={{ marginTop: "10px" }}
                                onClick={() => setShowAddServices(true)}
                            >
                                ➕ Добавить услугу
                            </button>
                        </>
                    ) : (
                        <>
                            <p>Услуги не найдены.</p>
                            <button
                                className="order-btn"
                                style={{ marginTop: "10px" }}
                                onClick={() => setShowAddServices(true)}
                            >
                                ➕ Добавить услугу
                            </button>
                        </>
                    )}


                    {/* Блок выбора новых услуг */}
                    {showAddServices && (
                        <div className="add-service-block">
                            <h4>Выберите услуги</h4>
                            {services.map(service => (
                                <div key={service.id} className="service-input-item">
                                    <input
                                        type="checkbox"
                                        checked={newServices.some(s => s.id === service.id)}
                                        onChange={(e) => handleToggleNewService(e, service)}
                                    />
                                    <label>{service.name}</label>
                                    <input
                                        type="number"
                                        min="0"
                                        placeholder="Количество"
                                        value={
                                            newServices.find(s => s.id === service.id)?.total_count || ""
                                        }
                                        onChange={(e) => handleNewServiceCount(e, service.id)}
                                        disabled={!newServices.some(s => s.id === service.id)}
                                    />
                                </div>
                            ))}

                            <button
                                className="order-btn"
                                style={{ marginTop: "10px" }}
                                onClick={handleSaveNewServices}
                            >
                                💾 Сохранить
                            </button>
                            <button
                                className="cancel-btn"
                                style={{ marginLeft: "10px" }}
                                onClick={() => {
                                    setShowAddServices(false);
                                    setNewServices([]);
                                }}
                            >
                                ❌ Отмена
                            </button>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default UserMngById;
